import styled from 'styled-components'
import { portraitAspectRatio } from '@velasca/constants'

export const PlayerWrapper = styled.div<{ aspectRatio?: number }>`
  width: 100%;
  height: 100%;
  aspect-ratio: ${({ aspectRatio }) => aspectRatio ?? portraitAspectRatio};
`
